<template>
  <div>
    <v-card-title class="primary--text pb-0 pt-0 pr-0" width="100%">
      Нагрузка
      <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn x-small dark v-on="on" :loading="pendingXls" color="green" class="mr-2 mb-1"  @click="generateXls">
              <v-icon color="white" small>mdi-file-excel</v-icon>
            </v-btn>
          </template>
          <span>Эксель</span>
        </v-tooltip>

        <input
          type="text"
          v-model="search"
          class="fast-search-input mr-3 mb-0"
          placeholder="Объект, пост .."
        />

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <span @click="recalc_all_shifts" class="pointer" v-on="on" name="clear"><v-icon :loading="loading" color="grey" class="mr-2">mdi-reload</v-icon></span>
        </template>
        <span>Пересчитать (при изменении ставки)</span>
      </v-tooltip>

      </v-card-title>

       <v-card light class="info-block mt-1">
         <v-data-table
          must-sort
          fixed-header
          :height="tableHeight - 140"
          dense
          :mobile="false"
          :options.sync="options"
          :headers="headers"
          disable-pagination
          :loading="loading"
          :items="items"
          :footer-props="footerProps"
          :header-props="{ mobile: false }"
          :server-items-length="count"
          class="dataTable elevation-1 data-table lazy-table"
          :hide-default-footer="true"
          :hide-default-header="false"
          :mobile-breakpoint="0"
          no-data-text="Нет данных"
          @update:sort-by="updateSort('by', $event)"
          @update:sort-desc="updateSort('desc', $event)"
         >
           <template v-slot:body="{ items }">
             <tbody v-infinite-scroll="load" infinite-scroll-disabled="scrollBusy" infinite-scroll-distance="1">
               <tr align="left" v-for="(item, index) in items" :key="item.id">
                 <td>
                   {{ index + 1 }}
                 </td>
                 <td v-for="field in fields" :key="field.id">
                   <div v-if="field === 'secureobject'" >
                     <router-link :to="{ name: 'secureobject_view', params: { id: item.secureobject.id }}">
                       {{ item[field]|default }}
                     </router-link>
                   </div>

                   <div v-else-if="field === 'post'" >
                     <router-link :to="{ name: 'post_view', params: { id: item.post.id }}">
                      {{ item[field]|default }}
                    </router-link>
                   </div>

                   <div v-else-if="field === 'amount'">
                     {{ item[field]|moneyFormatFilter }} р.
                   </div>

                   <div v-else-if="field === 'days'">
                      <v-row no-gutters>
                        <span v-if="view2 === 'edit'" class="pointer" @click="change(item, 'days', 'decr')"><v-icon class="mr-1" color="grey">mdi-minus-box-outline</v-icon></span>
                        <span class="mt-1">{{ item.days }} <span v-if="item.days_updated !== 0" :class="item.days_updated >= 0 ? 'green--text' : 'red--text'">({{ item.days_updated }})</span></span>
                        <span v-if="view2 === 'edit'" class="pointer" @click="change(item, 'days', 'incr')"><v-icon class="ml-1" color="grey">mdi-plus-box-outline</v-icon></span>

                      </v-row>
                   </div>

                   <div v-else-if="field === 'hours'" >
                     <v-row no-gutters>
                       <span v-if="view2 === 'edit'" class="pointer" @click="change(item, 'hours', 'decr')"><v-icon class="mr-1" color="grey">mdi-minus-box-outline</v-icon></span>
                       <span class="mt-1">{{ item.hours }} <span v-if="item.hours_updated !== 0" :class="item.hours_updated >= 0 ? 'green--text' : 'red--text'">({{ item.hours_updated }})</span></span>
                       <span v-if="view2 === 'edit'" class="pointer" @click="change(item, 'hours', 'incr')"><v-icon class="ml-1" color="grey">mdi-plus-box-outline</v-icon></span>
                     </v-row>
                   </div>

                   <div v-else-if="field === 'rates'" >
                     <div v-for="i in item.rates" :key="i.id">
                     <router-link v-if="['unit', 'combine'].includes(i.rate_type)" :to="{ name: 'rates_unit_list', query: { id: i.unit.id, no_cache: true }}">
                      {{ i.rate_type_ru }} {{ i.name }}
                    </router-link>

                     <router-link v-if="['post', 'combine'].includes(i.rate_type)" :to="{ name: 'rates_post_list', query: { id: item.post.id, no_cache: true }}">
                      {{ i.rate_type_ru }} {{ i.name }}
                    </router-link>
                    </div>
                   </div>

                   <div v-else>{{ item[field]|default }}</div>

                 </td>
               </tr>
               <tr>
                 <td v-if="!items.length && !loading" class="center-text" colspan="100">
                   <span class="no-data-text">Нет данных</span>
                 </td>
               </tr>
             </tbody>
           </template>
         </v-data-table>
      </v-card>


  </div>
</template>

<script>
import Date from '@/components/Date'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ScrollTable from '@/views/ScrollTable.vue'
import { getAll, get, edit, save, remove } from '@/api'

export default {
  mixins: [ScrollTable],
  components: {
    Date,
  },
  props: {
    id: {
      type: Number
    },
    item: {
      default: function () {
        return {}
      },
      type: Object
    },

    view2: {
      type: String,
      default: 'view'
    },
  },
  watch: {
    search () {
      const newQuery = { ...this.initialQuery, ...{ search: this.search } }
      if (!this.loading) {
        this.filteredLoad(newQuery)
      }
    }
  },
  computed: {
  },
  data: function () {
    return {
      urlList: `accounting/payroll/${this.id}/shifts/`,
      urlObj: 'accounting/payroll/shift/',

      initialQuery: { no_cache: true, sort_by: 'id', sort_desc: true },

      loadingRefs: {},

      search: '',

      loading: false,

      pendingSave: false,

      // tables
      columns: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Объект', align: 'left', width: 100, sortable: true, value: 'secureobject', default: true },
        { text: 'Пост', align: 'left', width: 100, sortable: true, value: 'post', default: true },
        { text: 'Начало', align: 'left', width: 100, sortable: true, value: 'range_start', default: true },
        { text: 'Конец', align: 'left', width: 100, sortable: true, value: 'range_end', default: true },
        { text: 'Смен', align: 'left', width: 100, sortable: true, value: 'days', default: true },
        { text: 'Часов', align: 'left', width: 100, sortable: true, value: 'hours', default: true },
        { text: 'Ставка', align: 'left', width: 70, sortable: true, value: 'rates', default: true },
        { text: 'Сумма', align: 'left', width: 70, sortable: true, value: 'amount', default: true },
        { value: 'hours_updated', hidden: true },
        { value: 'days_updated', hidden: true },
      ],
    }
  },
  methods: {
    externalInit () {
      this.columns = this.columns.filter((i) => {
        if (this.extra_data.load_type === 'days') {
          return i.value !== 'hours'
        } else {
          return i.value !== 'days'
        }
      })
    },
    recalc_all_shifts () {
      this.loading = true
      const url = this.urlList + 'recalc/'
      getAll(url).then((response) => {
        this.$store.commit('SET_LOADING', false)
        this.loading = false
        this.filteredLoad(this.initialQuery)
        this.$emit('load')
      }).catch((err) => {
        this.loading = false
        console.log('ERR', err.response.data)
        this.$store.commit('SET_LOADING', false)
      })
    },
    change (item, entity, action) {
      if (action === 'incr') {
        item[entity]++
        item[`${entity}_updated`]++
      } else {
        item[entity]--
        item[`${entity}_updated`]--
      }

      this.pendingSave = true
      this.$store.commit('SET_LOADING', true)

      edit(this.urlObj, item.id, item).then((response) => {
        this.$store.commit('SET_LOADING', false)
        this.pendingSave = false
        Object.assign(item, response.data)
        this.$emit('renew', item.payroll)
      }).catch((err) => {
        this.pendingSave = false
        this.$notify({ group: 'main', title: 'Изменить нагрузку', text: `Ошибка! ${err.response.data.detail}`, type: 'error' })
        console.log('ERR', err.response.data)
        this.$store.commit('SET_LOADING', false)
      })
    }
  },
}
</script>
<style scoped>
.fast-search-input {
  border: solid 1px;
  border-radius: 3px;
  border-color: #E0E0E0;
  padding: 2px;
  max-height: 28px;
}
</style>
